import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { AIAgent } from '../../types';
import AIAgentForm from './AIAgentForm';

interface AIAgentFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  agent?: AIAgent;
  onSubmit?: (agentData: any) => void;
}

const AIAgentFormModal: React.FC<AIAgentFormModalProps> = ({
  isOpen,
  onClose,
  agent,
  onSubmit,
}) => {
  const [modalVisible, setModalVisible] = useState(isOpen);

  useEffect(() => {
    setModalVisible(isOpen);

    // モーダルが開いているときはスクロールを無効化
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // クリーンアップ関数
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleSubmit = (agentData: any) => {
    if (onSubmit) {
      onSubmit(agentData);
    }
    onClose();
  };

  if (!modalVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1000] bg-black/50 flex items-center justify-center">
      <div className="relative w-[90%] max-w-[650px] max-h-[90vh] overflow-y-auto rounded-tasky-lg shadow-card">
        <button
          onClick={onClose}
          aria-label="閉じる"
          className="absolute top-5 right-5 w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:bg-warm-hover hover:text-dark transition-colors focus:outline-none focus:ring-2 focus:ring-primary/40"
        >
          <X className="w-5 h-5" />
        </button>
        <AIAgentForm
          agent={agent}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      </div>
    </div>
  );
};

export default AIAgentFormModal;
